import merchandiseSlice from './merchandiseSlice'

export default merchandiseSlice;